import { render, staticRenderFns } from "./LowTrafficStock.vue?vue&type=template&id=2bf9fbff&"
import script from "./LowTrafficStock.vue?vue&type=script&lang=js&"
export * from "./LowTrafficStock.vue?vue&type=script&lang=js&"
import style0 from "./LowTrafficStock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports